import { z } from "zod";

export const roomSchema = z.object({
	id: z.string(),
	name: z.string().optional().nullable(),
	description: z.string().nullable().optional(),
	profile_image_file_name: z.string().nullable().optional(),
	profile_image_fs_path: z.string().nullable().optional(),
	type: z.enum(["broadcast", "community", "group"]).optional(),
	created_by_account_id: z.string().optional(),
	deleted_at: z.string().datetime().nullable().optional(),
	inserted_at: z.string().datetime().optional(),
	updated_at: z.string().datetime().optional(),
});

export type IRoom = z.infer<typeof roomSchema>;
